import OverflowTip from './OverflowTip';

export default OverflowTip;
